import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { active: String }

  connect() {
    const stageFromUrl = new URL(window.location.href).searchParams.get("stage")
    if (stageFromUrl && this.hasTabForStage(stageFromUrl)) this.activeValue = stageFromUrl
    this.showActiveStage()
  }

  select(event) {
    event.preventDefault()
    this.activate(event.currentTarget.dataset.stage)
  }

  keydown(event) {
    const keys = ["ArrowLeft", "ArrowRight", "Home", "End"]
    if (!keys.includes(event.key)) return

    event.preventDefault()
    const currentIndex = this.tabTargets.indexOf(event.currentTarget)
    let nextIndex = currentIndex

    if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % this.tabTargets.length
    if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + this.tabTargets.length) % this.tabTargets.length
    if (event.key === "Home") nextIndex = 0
    if (event.key === "End") nextIndex = this.tabTargets.length - 1

    const nextTab = this.tabTargets[nextIndex]
    this.activate(nextTab.dataset.stage)
    nextTab.focus()
  }

  activate(stage) {
    this.activeValue = stage
    this.persistStage(stage)
    this.showActiveStage()
  }

  showActiveStage() {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.stage === this.activeValue
      tab.setAttribute("aria-selected", active ? "true" : "false")
      tab.setAttribute("tabindex", active ? "0" : "-1")
      if (active) {
        tab.setAttribute("aria-current", "step")
      } else {
        tab.removeAttribute("aria-current")
      }
      tab.classList.toggle("is-selected", active)
    })

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.stage !== this.activeValue
    })
  }

  persistStage(stage) {
    const url = new URL(window.location.href)
    url.searchParams.set("stage", stage)
    window.history.replaceState({}, "", url)
  }

  hasTabForStage(stage) {
    return this.tabTargets.some((tab) => tab.dataset.stage === stage)
  }
}
